import { FC } from 'react'
import { useField } from 'formik-latest'
import cn from 'classnames'

import { ReactComponent as IconAlert } from 'images/icons/alert.svg'

import styles from './TextInput.module.scss'

interface TextInputProps {
  className?: string
  id: string
  name: string
  type: string
  min: string
}

/* @ts-ignore TODO: remove ignore TS validation */
const TextInput: FC<TextInputProps> = ({ className = '', children, ...props }) => {
  const [field, meta] = useField(props)
  const hasError = meta.error
  const errorClass = hasError ? styles.error : ''

  return (
    <>
      <input className={cn(className, errorClass)} {...field} {...props} />
      {children}
      {hasError && (
        <div className={styles.errorMessage}>
          <IconAlert /> {meta.error}
        </div>
      )}
    </>
  )
}

export default TextInput
